var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("Reporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("stop")]),
          _vm._v(" Finalizar\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  [
                    _c("v-card-actions", [
                      _c("div", [
                        _c("h4", { staticClass: "primary--text" }, [
                          _vm._v("Reporte de ficha personal")
                        ])
                      ]),
                      _vm._v("\n               \n            "),
                      _c(
                        "div",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                color: "red",
                                dark: "",
                                title: "Generar reporte PDF"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.reporte()
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("picture_as_pdf")])],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-justify" }, [
                      _vm._v(
                        "\n            Declaro que la información en la presente Ficha Personal es\n            fidedigna y constituye Declaración Jurada, la misma que autorizo\n            sea verificada en el momento que se considere pertinente por la Administracion de Servicios Portuarios - Bolivia,\n            caso contrario me someto a las sanciones establecidas en la ley Nro. 1178 de\n            Administración y Control Gubernamental y lo estipulado en el\n            Reglamento Interno de Personal (RIP).\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.estado == 1
                      ? _c(
                          "v-flex",
                          { attrs: { xs6: "", sm3: "" } },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                label: "Acepto",
                                value: "Acepto",
                                rules: [
                                  function(v) {
                                    if (v == null) {
                                      return "El campo es obligatorio."
                                    }
                                    return true
                                  }
                                ]
                              },
                              model: {
                                value: _vm.form.id_parametro_ta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "id_parametro_ta", $$v)
                                },
                                expression: "form.id_parametro_ta"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c("v-spacer"),
                        _vm._v(" "),
                        _vm.estado == 1
                          ? _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  type: "submit",
                                  loading: _vm.loading,
                                  disabled: !_vm.valid
                                }
                              },
                              [
                                _c("v-icon", { attrs: { dark: "" } }, [
                                  _vm._v("check")
                                ]),
                                _vm._v(" Finalizar\n            ")
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d014ba6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d014ba6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/Final.vue
// module id = null
// module chunks = 